import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader

// import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/lib/util/colors'

// see https://vuetifyjs.com/en/features/theme/#customizing
// for theming info

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi' || 'fa', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
  },
  theme: {
    options: { customProperties: true },
    dark: false,
    themes: {
      light: {
        primary: '#374a5a', //'#0675AD',
        secondary: '#a49283',
        accent: '#545C60',
        // error: '#FF5252',
        // info: '#2196F3',
        // success: '#4CAF50',
        // warning: '#FFC107',
      },
      dark: {
        primary: '#374a5a',
        secondary: '#a49283',
        accent: '#545C60',
        // error: '#FF5252',
        // info: '#2196F3',
        // success: '#4CAF50',
        // warning: '#FFC107',
      },
      // To switch to a dark theme, place the colors you want to use within the code below, uncomment
      // and uncomment dark: true above
      // dark: {
      //   primary: colors.indigo,
      //   secondary: colors.indigo.lighten4,
      //   accent: colors.indigo.base,
      // }
    },
  },
})
